// extracted by mini-css-extract-plugin
export default {"container":"_29pVo","button":"YC9O-","icon":"_3FB8K","text":"Lruuy","title":"WAaRm","info":"WMgMP"};